import { domainNamesData } from '../../interface/response/UserRolesResponse'

export const validateEmailDomain = (
  value: string,
  allowedDomainsString: domainNamesData[],
) => {
  if (!value || !allowedDomainsString) {
    return true // Let Yup handle required field validation
  }

  const emailParts = value.split('@')
  if (emailParts.length !== 2) {
    return false // Invalid email format
  }

  const emailDomain = emailParts[1].toLowerCase()
  const domainNames = allowedDomainsString.map((item) => item.domainName)
  const allowedDomains = domainNames.map((domain) =>
    domain.trim().toLowerCase(),
  )

  return allowedDomains.includes(emailDomain)
}

export const phoneRegExp = /^[0-9*()+ ]+$/

export const emailRegExp = /@atlas.energy$/
